import { create } from "@lottiefiles/lottie-interactivity";
import $ from "jquery";
import smallFloaties from "./small-floaties.json";
import medFloaties from "./med-floaties.json";
import convergingFloaties from "./converging-floaties.json";
import floaties from "./floaties.json";

$(() => {
  const lotties = $("lottie-player");
  if (lotties.length > 0) {
    lotties.each((i, lottieEl) => {
      const lottie = $(lottieEl);
      const file = lottie.data("lottie");
      switch (file) {
        case "floaties":
          lottieEl.load(floaties);
          if (i % 2 === 0) {
            lottieEl.setDirection(1);
          } else {
            lottieEl.setDirection(-1);
          }
          break;
        case "smallFloaties":
          lottieEl.load(smallFloaties);
          break;
        case "medFloaties":
          lottieEl.load(medFloaties);
          break;
        case "convergingFloaties":
          lottieEl.load(convergingFloaties);

          create({
            mode: "scroll",
            player: lottieEl,
            actions: [
              {
                visibility: [0, 0.9],
                type: "seek",
                frames: [0, 485]
              }
            ]
          });
          break;
        default:
          break;
      }
    });
  }
});
